import { style } from '@vanilla-extract/css';
import { themeVars } from '@customerio/pluma-components/css/theme-tokens';
import {
  gradientRingGlowOpacityTransition,
  gradientRingRootGlowChild,
} from '@/components/feedback/gradient-ring/index.css';

export const sparkleWrap = style(
  {
    position: 'relative',
    display: 'inline-flex',
    width: themeVars.space['200'],
    height: themeVars.space['200'],
    flexShrink: 0,
  },
  'ask-agent-sparkle-wrap',
);

export const sparklePluma = style(
  {
    position: 'absolute',
    inset: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    opacity: 1,
    transition: gradientRingGlowOpacityTransition,

    selectors: {
      [gradientRingRootGlowChild]: {
        opacity: 0,
      },
    },
    '@media': {
      '(prefers-reduced-motion: reduce)': {
        transition: 'none',
      },
    },
  },
  'ask-agent-sparkle-pluma',
);

export const sparkleGradientAlways = style(
  {
    position: 'absolute',
    inset: 0,
    display: 'block',
    width: '100%',
    height: '100%',
  },
  'ask-agent-sparkle-gradient-always',
);

export const sparkleGradient = style(
  {
    position: 'absolute',
    inset: 0,
    display: 'block',
    width: '100%',
    height: '100%',
    opacity: 0,
    transition: gradientRingGlowOpacityTransition,

    selectors: {
      [gradientRingRootGlowChild]: {
        opacity: 1,
      },
    },
    '@media': {
      '(prefers-reduced-motion: reduce)': {
        transition: 'none',
      },
    },
  },
  'ask-agent-sparkle-gradient',
);
